import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectvalue'
})
export class ObjectValues implements PipeTransform {

  transform(value:{}) {
    return Object.values(value)
  }

}